export enum BenefitStatus {
  Referred = "Referred",
  Declined = "Declined",
  NotTakenUp = "NotTakenUp",
  Accepted = "Accepted",
  WaitingForConfirmation = "WaitingForConfirmation",
  Initialized = "Initialized",
}
